import z from 'zod';

export function idSchema(field: string) {
  return z.string().regex(/^\d+$/, { message: `Invalid ${field}` });
}
